var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartBlockCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "17.99mm",
    height: "14.58mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 51 41.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 25.5,
    y1: 1122.16,
    x2: 25.5,
    y2: 1101.65,
    gradientTransform: "translate(0 -1091.28)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#fff",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M21.58,30.92c-2.65,0-5.2-1.05-7.07-2.94-1.88-1.87-2.94-4.42-2.93-7.07,0-5.69,4.58-10.5,10-10.5h14.47s0,5.6,0,5.6h3.35s0,9.32,0,9.32h-3.35s0,5.59,0,5.59h-14.47Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.58,30.42c-5.24,0-9.5-4.27-9.5-9.51,0-5.24,4.27-10,9.5-10h13.97s0,5.6,0,5.6h3.35s0,8.33,0,8.33h-3.35s0,5.59,0,5.59h-13.97Z",
    style: {
      fill: "#c9bf8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.58,29.92c-2.39,0-4.68-.95-6.36-2.64-1.69-1.68-2.64-3.97-2.64-6.36,0-4.96,4.04-8.5,9-8.5h13.47s0,5.6,0,5.6h3.35s0,6.33,0,6.33h-3.35s0,5.59,0,5.59h-13.47Z",
    style: {
      fill: "#34332b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBlockCategory);
export default __webpack_public_path__ + "static/media/start_block_category.6855c8c831ec7d284b09ab661d108eaf.svg";
export { ForwardRef as ReactComponent };